import React, { useEffect, useState } from 'react'
import TabelaSimples from './index'

function concatenaLista(lista) {
    let listaItens = ""
    lista.forEach((value, index) => {
        if (index === 0) {
            listaItens += value
        } else {
            listaItens += `, ${value}`
        }
    })
    return listaItens
}

function createData(id, social_name, client, responsible, items, brands, damage) {
    return {
        id,
        social_name,
        client,
        responsible,
        damage,
        items: concatenaLista(items),
        brands: concatenaLista(brands)
    };
}

const headCells = [
    {
        id: 'id',
        numeric: true,
        disablePadding: false,
        label: 'Código AT',
    },
    {
        id: 'social_name',
        numeric: false,
        disablePadding: false,
        label: 'Associado',
    },
    {
        id: 'damage',
        numeric: false,
        disablePadding: false,
        label: 'Dano reclamado',
    },
    {
        id: 'client',
        numeric: false,
        disablePadding: false,
        label: 'Cliente',
    },
    {
        id: 'responsible',
        numeric: false,
        disablePadding: false,
        label: 'Responsabilidade',
    },
    {
        id: 'items',
        numeric: false,
        disablePadding: false,
        label: 'Peças',
    },
    {
        id: 'brands',
        numeric: false,
        disablePadding: false,
        label: 'Marcas',
    },
]

const valueCells = [
    {
        value: 'id',
        alignment: 'center'
    },
    {
        value: 'social_name',
        alignment: 'left'
    },
    {
        value: 'damage',
        alignment: 'left'
    },
    {
        value: 'client',
        alignment: 'left'
    },
    {
        value: 'responsible',
        alignment: 'left'
    },
    {
        value: 'items',
        alignment: 'left'
    },
    {
        value: 'brands',
        alignment: 'left'
    },
]

export default function OcorrenciasUsuario({ocorrencias, onClick, toolbarAction, children}) {
    const [linhas, setLinhas] = useState([])
    useEffect(() => {
        if(ocorrencias) {
            const listaOcorrencias = ocorrencias.map(value => createData(value.id, value.social_name, value.client, value.responsible, value.items, value.brands, value.damage))

            setLinhas(listaOcorrencias)
        }
    }, [ocorrencias])

    return (
        <TabelaSimples
            headCells={headCells}
            linhas={linhas}
            valueCells={valueCells}
            titulo="Ocorrências"
            toolbarAction={toolbarAction}
            onClick={onClick}>
            {children}
        </TabelaSimples>
    )
}
